import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalyticsPagePath } from '../analyticsPagePath';

function AnalyticsPageView() {
  const location = useLocation();
  const lastTrackedPath = useRef(null);
  const navigationPath = `${location.pathname}${location.search}`;
  const pagePath = getAnalyticsPagePath(location.pathname, location.search);

  useEffect(() => {
    if (lastTrackedPath.current === navigationPath) return;
    lastTrackedPath.current = navigationPath;

    window.gtag?.('event', 'page_view', {
      page_title: document.title,
      page_location: `${window.location.origin}${pagePath}`,
      page_path: pagePath,
    });
  }, [navigationPath, pagePath]);

  return null;
}

export default AnalyticsPageView;
